
import { Component, Vue } from 'vue-property-decorator';
import { dispatchGetBasic, dispatchSetUpBasic } from '@/store/setup/actions';
import { IBasic } from '@/store/setup';
import { growth_phases, industries, industry_details } from '@/utils/const';
import { commitAddNotification } from '@/store/main/mutations';

@Component
export default class Basic extends Vue {
  public company_url: string = '';
  public company_name: string = '';
  public company_growth_phase: string = '-';
  public company_foundation_date: string | null = null;
  public company_industry_category1: string = '-';
  public company_industry_detail1: string | null = null;
  public company_industry_category2: string = '-';
  public company_industry_detail2: string | null = null;
  public company_industry_category3: string = '-';
  public company_industry_detail3: string | null = null;
  public user_last_name: string = '';
  public user_first_name: string = '';
  public user_title: string = '';
  public user_expectation: string[] = [];

  public year: number | null = null;
  public month: number | null = null;
  public day: number | null = null;
  public expectations: string[] = [
    "資金調達の最新ニュースを知りたい",
    "資金調達方法を学びたい",
    "自分が活用できる補助金や助成金が知りたい",
    "資金調達のスケジュールを知りたい",
    "資金調達に向けて具体的に何をすべきかを知りたい",
    "信頼できる専門家に相談したい",
    "作成した資料に対するフィードバックが欲しい",
    "親和性が高い金融機関や投資家を知りたい"];
  public selected: number[] = [];

  get getIndustries() {
    return industries;
  }

  public getDetail(category: string | null) {
    if (!['', '-'].includes(this.company_industry_category1)) {
      if (!industry_details[this.company_industry_category1].includes(this.company_industry_detail1)) {
        this.company_industry_detail1 = null;
      }
    } else {
      this.company_industry_category1 = '-';
      this.company_industry_detail1 = null;
      this.company_industry_category2 = '-';
      this.company_industry_detail2 = null;
      this.company_industry_category3 = '-';
      this.company_industry_detail3 = null;
    }
    if (!['', '-'].includes(this.company_industry_category2)) {
      if (!industry_details[this.company_industry_category2].includes(this.company_industry_detail2)) {
        this.company_industry_detail2 = null;
      }
    } else {
      this.company_industry_category2 = '-';
      this.company_industry_detail2 = null;
      this.company_industry_category3 = '-';
      this.company_industry_detail3 = null;
    }
    if (!['', '-'].includes(this.company_industry_category3)) {
      if (!industry_details[this.company_industry_category3].includes(this.company_industry_detail3)) {
        this.company_industry_detail3 = null;
      }
    } else {
      this.company_industry_category3 = '-';
      this.company_industry_detail3 = null;
    }
    return (category)
      ? industry_details[category]
      : null;
  }

  public checkGrowthPhase() {
    if (!this.company_growth_phase) {
      this.company_growth_phase = '-';
    }
  }

  get getGrowthPhases() {
    return growth_phases;
  }

  public async mounted() {
    this.reset();
  }

  public async reset() {
    const basic = await dispatchGetBasic(this.$store);
    if (basic) {
      if (basic.company_url) {
        this.company_url = basic.company_url;
      }
      if (basic.company_name) {
        this.company_name = basic.company_name;
      }
      if (basic.company_foundation_date) {
        let date = new Date(basic.company_foundation_date);
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.day = date.getDate();
      }
      if (basic.company_industry_category1) {
        this.company_industry_category1 = this.extractIndustry('text', basic.company_industry_category1)!;
        this.company_industry_detail1 = basic.company_industry_detail1;
      }
      if (basic.company_industry_category2) {
        this.company_industry_category2 = this.extractIndustry('text', basic.company_industry_category2)!;
        this.company_industry_detail2 = basic.company_industry_detail2;
      }
      if (basic.company_industry_category3) {
        this.company_industry_category3 = this.extractIndustry('text', basic.company_industry_category3)!;
        this.company_industry_detail3 = basic.company_industry_detail3;
      }
      if (basic.company_growth_phase) {
        this.company_growth_phase = basic.company_growth_phase;
      }
      if (basic.user_last_name) {
        this.user_last_name = basic.user_last_name;
      }
      if (basic.user_first_name) {
        this.user_first_name = basic.user_first_name;
      }
      if (basic.user_title) {
        this.user_title = basic.user_title;
      }
      if (basic.user_expectation.length > 0) {
        for (let str of basic.user_expectation) {
          this.selected.push(this.expectations.indexOf(str));
        }
      }
    }
    this.$validator.reset();
  }

  public async save() {
    this.setVariable();
    const basic: IBasic = {
      company_url: this.company_url,
      company_name: this.company_name,
      company_foundation_date: this.company_foundation_date,
      company_industry_category1: this.extractIndustry('value', this.company_industry_category1),
      company_industry_detail1: this.company_industry_detail1,
      company_industry_category2: this.extractIndustry('value', this.company_industry_category2),
      company_industry_detail2: this.company_industry_detail2,
      company_industry_category3: this.extractIndustry('value', this.company_industry_category3),
      company_industry_detail3: this.company_industry_detail3,
      company_growth_phase: (this.company_growth_phase) ? this.company_growth_phase : '',
      user_last_name: this.user_last_name,
      user_first_name: this.user_first_name,
      user_title: this.user_title,
      user_expectation: this.user_expectation
    };
    await dispatchSetUpBasic(this.$store, basic);
    commitAddNotification(this.$store, { content: '保存されました', condition: 'saved' });
    this.reset();
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      this.setVariable();
      const basic: IBasic = {
        company_url: this.company_url,
        company_name: this.company_name,
        company_foundation_date: this.company_foundation_date,
        company_industry_category1: this.extractIndustry('value', this.company_industry_category1),
        company_industry_detail1: this.company_industry_detail1,
        company_industry_category2: this.extractIndustry('value', this.company_industry_category2),
        company_industry_detail2: this.company_industry_detail2,
        company_industry_category3: this.extractIndustry('value', this.company_industry_category3),
        company_industry_detail3: this.company_industry_detail3,
        company_growth_phase: (this.company_growth_phase) ? this.company_growth_phase : '',
        user_last_name: this.user_last_name,
        user_first_name: this.user_first_name,
        user_title: this.user_title,
        user_expectation: this.user_expectation,
      };
      await dispatchSetUpBasic(this.$store, basic);
      this.$router.push('/setup/product');
    }
  }

  public resetDay() {
    this.day = 0;
  }

  public years() {
    const years: number[] = [];
    for (let year = (new Date().getFullYear() - 30); year <= (new Date().getFullYear() + 1); year++) {
      years.push(year);
    }
    return years;
  }

  public months() {
    const months = [...Array(12)].map((ele, i) => i + 1);
    return months;
  }

  public days() {
    const days: number[] = [];
    const date = (this.year && this.month) ? new Date(this.year, this.month, 0) : new Date();
    for (let day = 1; day <= date.getDate(); day++) {
      days.push(day)
    }
    return days
  }

  public setVariable() {
    if (this.year && this.month && this.day) {
      this.company_foundation_date = this.year.toString() + '-' + this.month.toString() + '-' + this.day.toString()
    }
    this.user_expectation = [];
    if (this.selected.length > 0) {
      for (let num of this.selected.sort()) {
        this.user_expectation.push(this.expectations[num]);
      }
    }
  }

  public extractIndustry(extracter: 'value' | 'text', param: string | null): string | null {
    let str: string | null = null;
    for (let industry of industries) {
      if (extracter == 'value' && industry.value == param && param) {
        str = industry.text;
      } else if (extracter == 'text' && industry.text == param) {
        str = industry.value;
      }
      if (str != null) break;
    }
    return str;
  }

  get isComplete() {
    return this.company_name
      && this.year && this.month && this.day
      && this.company_industry_category1 && this.company_industry_detail1
      && this.user_last_name && this.user_first_name
      && this.user_title
      && this.selected.length > 0;
  }
}
